export default "__VITE_ASSET__a8ef1600__"